import {
	SHOW_MANUAL_ACTIVATION_MODAL,
	CLOSE_MANUAL_ACTIVATION_MODAL,
	UPDATE_MANUAL_ACTIVATION_FIELD
} from '../actions/manualActivation.js'

const manualActivationReducer = (state = {showManualActivationModal: false, info: {}}, action) => {
	switch (action.type) {
		case SHOW_MANUAL_ACTIVATION_MODAL:
			return {
				...state,
			  showManualActivationModal: true,
        info: {}
			}
		case CLOSE_MANUAL_ACTIVATION_MODAL:
			return {
				...state,
				showManualActivationModal: false
			}
		case UPDATE_MANUAL_ACTIVATION_FIELD:
			return {
				...state,
				info: {...state.info, [action.name]: action.value},
			}
		default:
			return state
	}
}

export default manualActivationReducer;



// WEBPACK FOOTER //
// ./src/reducers/manualActivation.js